<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="titleText"
    cancel-btn="Отменить"
    success-btn="Добавить"
    @submit="onSubmit"
    @closed="$emit('closed')"
  >
    <v-row dense>
      <v-col cols="12">
        <BTextField
          v-model="form.src"
          label="Ссылка на картинку"
          autofocus
        />
      </v-col>

      <v-col cols="12">
        <BTextField
          v-model="form.alt"
          label="Название картинки"
        />
      </v-col>
    </v-row>

    <template #footer-before>
      <BEditorFileUpload
        accept="image/*"
        :tag="$options.tag"
        @input="onUpload"
      />
    </template>
  </BModalConfirm>
</template>

<script>
import { FILE_TAG_IMAGE } from '@/helpers/enums/params'
import { SETTINGS } from './utils'

import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BEditorFileUpload from './BEditorFileUpload.vue'


const createDefaultData = () => ({
  src: '',
  alt: '',
})

export default {
  name: 'BEditorModalImage',
  components: {
    BModalConfirm,
    BTextField,
    BEditorFileUpload,
  },
  inheritAttrs: false,
  props: {
    active: {
      type: Boolean,
    },
  },
  tag: FILE_TAG_IMAGE,
  data: () => ({
    form: createDefaultData(),
    titleText: SETTINGS.image[1],
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close(flag) {
      return this.$refs.modal.close(flag)
    },
    onUpload(file) {
      const src = file?.url
      const alt = file?.name
      this.form = { src, alt }
    },
    onSubmit() {
      this.close(this.form)
    },
  },
}
</script>
